import { Navigate, Outlet } from "react-router-dom";
import { logger, useAuth } from "../core";
import { toastService } from "@/core/services/toast.service";
import { useAppDispatch } from "@/store/hooks";
import { clearUser } from "@/store/slices/auth";

const ProtectedRoutes = () => {
  const dispatch = useAppDispatch();
  const {
    // isLoading,
    error,
    isError,
    isSuccess,
    data: sessionResponse,
  } = useAuth();
  logger.warn("data from get session ===> useAuth() ", sessionResponse);
  if (isError) {
    toastService.error("Not Found", error?.message as string);
    dispatch(clearUser());
    return <Navigate to="/login" />;
  }
  if (isSuccess) {
    return <Outlet />;
  }
};
export default ProtectedRoutes;

/**
 * Layer 1 of the route protection: "is there a session at all?"
 * On success it BRIDGES the session into Redux — that's what feeds
 * selectIsAuthenticated / selectHasPaid, which the paid/unpaid guards
 * (layer 2) read. Without this dispatch, the guards spin forever.
 */
// const ProtectedRoutes = () => {
//   const dispatch = useAppDispatch();
//   const { error, isError, isSuccess, data: sessionResponse } = useAuth();
//   console.log("sessionResponse", sessionResponse);

//   // Sync session → store. Effects, never render: render must stay pure.
//   useEffect(() => {
//     if (isSuccess && sessionResponse?.data) {
//       // adjust `.user` to your actual response shape
//       dispatch(setUser(sessionResponse?.data));
//     }
//   }, [isSuccess, sessionResponse, dispatch]);

//   useEffect(() => {
//     if (isError) {
//       dispatch(clearUser());
//       toastService.error(
//         "Session expired",
//         (error?.message as string) ?? "Please log in again",
//       );
//     }
//   }, [isError, error, dispatch]);

//   if (isError) {
//     // Absolute path + replace. Relative "login" resolves against the
//     // CURRENT url — from /payment/methods/credit-card it would go to
//     // /payment/methods/login. replace keeps the dead page out of history.
//     return <Navigate to="/login" replace />;
//   }

//   if (!isSuccess) {
//     // Pending — previously this branch returned undefined (blank screen)
//     return (
//       <div
//         style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}
//       >
//         <Spinner size="md" />
//       </div>
//     );
//   }

//   return <Outlet />;
// };
// export default ProtectedRoutes;
